/**
 * Royal Carnet Selector
 * ---------------------------------------------------------------------------
 * Gere l'ecran de selection façon Apple Wallet : le client choisit une
 * carte (carnet), le sélecteur se masque et le carnet flipbook
 * correspondant (section royal-carnet-flipbook avec part_of_selector actif)
 * s'affiche a sa place. Le bouton "Retour aux carnets" ramene a l'ecran de
 * selection.
 *
 * N'importe jamais assets/royal-carnet-flipbook.js : on reutilise
 * uniquement son API publique (window.RoyalCarnetFlipbook.init) pour
 * relancer les mesures de mise en page une fois le carnet redevenu visible.
 * ---------------------------------------------------------------------------
 */
(function () {
  'use strict';

  function initSelector(root) {
    if (root.dataset.rcsInit === 'true') return;
    root.dataset.rcsInit = 'true';

    var cards = Array.from(root.querySelectorAll('[data-rcs-card]'));
    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        activateCarnet(root, card.getAttribute('data-target-carnet'));
      });
    });
  }

  function activateCarnet(selectorRoot, key) {
    if (!key) return;
    var panel = document.querySelector('.rf2-wrapper[data-carnet-key="' + cssEscape(key) + '"]');
    if (!panel) return;

    // Referme un autre carnet resté ouvert, le cas échéant.
    Array.from(document.querySelectorAll('.rf2-wrapper.rf2-selector-panel.is-active-carnet')).forEach(function (p) {
      if (p !== panel) p.classList.remove('is-active-carnet');
    });

    selectorRoot.classList.add('rcs-hidden');
    panel.classList.add('is-active-carnet');

    // Le flipbook a pu s'initialiser pendant qu'il était masqué
    // (display:none) ; on relance init() pour que les mesures de mise en
    // page (ex. clamp de description, IntersectionObserver) soient
    // correctes maintenant qu'il est visible. init() est idempotent :
    // il detruit puis recree proprement l'instance existante.
    if (window.RoyalCarnetFlipbook) {
      var sectionId = panel.id.replace(/^rf2-/, '');
      window.RoyalCarnetFlipbook.init(sectionId);
    }

    window.requestAnimationFrame(function () {
      panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  function backToSelector(panel) {
    panel.classList.remove('is-active-carnet');
    var selectorRoot = document.querySelector('.rcs-wrapper');
    if (!selectorRoot) return;
    selectorRoot.classList.remove('rcs-hidden');
    window.requestAnimationFrame(function () {
      selectorRoot.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  function cssEscape(value) {
    if (window.CSS && window.CSS.escape) return window.CSS.escape(value);
    return String(value).replace(/["\\]/g, '\\$&');
  }

  // Delegation globale pour le bouton retour, present a l'interieur de
  // chaque carnet marque part_of_selector (voir royal-carnet-flipbook.liquid).
  document.addEventListener('click', function (e) {
    var backBtn = e.target.closest('[data-rf2-back]');
    if (!backBtn) return;
    var panel = backBtn.closest('.rf2-wrapper');
    if (panel) backToSelector(panel);
  });

  function initAll(scope) {
    Array.from((scope || document).querySelectorAll('.rcs-wrapper')).forEach(initSelector);
  }

  document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
